import { toCSSPixel } from '../../../../utils/styles'

import { GAP_SIZE, MAX_WIDTH_FOR_FIRST_ROW } from './SelectButton.constants'

export function getMaxWidth(current) {
  return current
    ? `calc(100% - ${current?.offsetWidth}px - ${GAP_SIZE}px)`
    : toCSSPixel(MAX_WIDTH_FOR_FIRST_ROW)
}
